// extracted by mini-css-extract-plugin
module.exports = {"root":"WarrantyDocs_root__1AE1T","single":"WarrantyDocs_single__3hC78","pagination":"WarrantyDocs_pagination__1Rp-4","button":"WarrantyDocs_button__1uvKA"};